import { FormikProps } from 'formik'
import { FC } from 'react'
import { ShipLoadWorkTypes } from 'modules/domain/deal/types'
import { t } from 'i18next'
import _ from 'lodash'
import { RadioItem } from '@agro-club/agroclub-shared'
import { FormCheckboxGroup } from 'views/components/CheckboxGroup/CheckboxGroup'
import { FormRadio } from 'views/components/form/FormRadio'

type Props = {
  formik: FormikProps<any>
  multiple: boolean
}

export const ShipWorkTypeSelect: FC<Props> = ({ formik, multiple }) => {
  const fieldName = 'work_type'
  const label = t('deal:accordion.loading.operationType')
  if (multiple) {
    return (
      <FormCheckboxGroup
        keys={Object.keys(ShipLoadWorkTypes)}
        fieldName={fieldName}
        formik={formik}
        formGroupLabel={label}
        checkboxLabel="deal:accordion.loading"
      />
    )
  }
  return (
    <FormRadio label={label} formik={formik} field={fieldName}>
      <RadioItem value={ShipLoadWorkTypes.sample} label={t('deal:accordion.loading.sample')} />
      <RadioItem value={ShipLoadWorkTypes.unloading} label={t('deal:accordion.loading.unloading')} />
      <RadioItem value={ShipLoadWorkTypes.ship_loading} label={t('deal:accordion.loading.ship_loading')} />
    </FormRadio>
  )
}
